// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3agVy","label":"styles_label__2EW3D"};